import React, {Component} from 'react'
import {connect} from "react-redux";
import {Col, ControlLabel, Grid, Row} from "react-bootstrap";
import BackLink from '../../../../common/back-link';
import PageTitle from "../../../../common/page-title";
import {getProducts} from "../../../../../actions/products";
import {getUpsellPopup, saveUpsellPopup, updateUpsellPopup} from "../../../../../actions/upsell_popups";
import {actions, Form} from "react-redux-form";
import RequiredInput from "../../../../common/form/elements/required-input";
import MultiSelect from "../../../../common/form/elements/multi-select";
import ArrowButton from '../../../../common/button-arrow';
import ImageUpload from "../../../../common/form/elements/image-upload";
import Wording from "./wording-editor";

class NewUpsellPopup extends Component {
  constructor(props) {
    super(props);
    this.id = this.props.match.params.id;
  }

  componentDidMount() {
    const {dispatch} = this.props;
    dispatch(getProducts());
    if (this.isEdit()) {
      dispatch(getUpsellPopup(this.id)).then((upsell_popup) => {
        dispatch(actions.load('deep.admin_upsell_popup_save', upsell_popup));
      });
    } else {
      dispatch(actions.reset('deep.admin_upsell_popup_save'));
    }
  }

  componentWillUnmount() {
    this.props.dispatch({type: 'CLEAR_UPSELL_POPUPS'});
    this.props.dispatch(actions.reset('deep.admin_upsell_popup_save'));
  }

  isEdit = () => this.id && parseInt(this.id);

  isUpsellPopupLoading = () => this.isEdit() && this.props.upsell_popupLoading;

  handleSubmit = (payLoad) => {
    const {dispatch} = this.props;
    if (this.isEdit()) {
      dispatch(updateUpsellPopup(this.id, payLoad));
    } else {
      dispatch(saveUpsellPopup(payLoad));
    }
  };

  createProductList = products => products.flatMap((category) => (
    category.attributes.products.map((product) => ({
        label: `${product.name}`,
        value: product.id
      })
    )
  ));

  handleChange(event, that) {
    const {dispatch} = this.props;
    let model='deep.admin_upsell_popup_save.product_ids';

    dispatch(actions.setErrors(model, {
      required: event.target.value !== "true"
    }));

    if(event.target.value === "true"){
      dispatch(actions.change(model, []));
    }
  }

  render() {
    const {products: productList, savedProducts, formValid} = this.props;
    const products = this.createProductList(productList);

    if (this.isUpsellPopupLoading()) {
      return (
        <div className="container-fluid">
          <PageTitle>{this.isEdit() ? 'Edit Upsell Popup' : 'Add Upsell Popup'}</PageTitle>
          <Row>
            <Col lg={12}>
              Loading...
            </Col>
          </Row>
        </div>
      )
    }

    let image = '';
    if (this.props.formData.hasOwnProperty('links') && this.props.formData.links.hasOwnProperty('image')) {
      image = this.props.formData.links.image;
    }

    return (
      <Grid bsClass="container" fluid className="upsell_popup">
        <Form model="deep.admin_upsell_popup_save" onSubmit={(data) => this.handleSubmit(data)}>
          <Row>
            <Col lg={12}>
              <BackLink href="/admin/upsell_popups"/>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <PageTitle>{this.isEdit() ? 'Edit Upsell Popup' : 'Add Upsell Popup'}</PageTitle>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredInput
                label="Title"
                placeholder="Title"
                model='.title'
                controlId='title'
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <ControlLabel>Image*</ControlLabel>
              <ImageUpload
                onImageLoaded={this.onImageLoaded}
                source={image}
                label={"Upload an image (1500 x 300)"}
                model="deep.admin_upsell_popup_save.image"
                type={['image/png', 'image/jpg', 'image/jpeg']}
                required/>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Wording />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <MultiSelect
                data={products || []}
                label="Trigger Product/s"
                value={savedProducts}
                controlId="products"
                model='deep.admin_upsell_popup_save.product_ids'
              />
            </Col>
          </Row>
          <Row>
            <Col md={2} mdOffset={10}>
              <ArrowButton
                className="pull-right"
                arrow={false}
                disabled={!formValid}
              >
                Save
              </ArrowButton>
            </Col>
          </Row>
        </Form>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => ({
  formData: state.deep.admin_upsell_popup_save,
  formValid: state.deep.forms.admin_upsell_popup_save.$form.valid,
  upsell_popup: state.upsellPopups.upsell_popup,
  upsell_popupLoading: state.upsellPopups.fetching && !state.upsellPopups.fetched,
  savedProducts: state.deep.admin_upsell_popup_save.product_ids || [],
  products: state.products.products || []});

export default connect(mapStateToProps)(NewUpsellPopup);



// WEBPACK FOOTER //
// ./src/components/admin/promotions/upsell_popups/add/index.jsx